export default __webpack_public_path__ + "static/media/butterflies-trees.5005eb39.gif";